type MatchFn = (a: any, b: any) => boolean;

// compare contents of two arrays using a matcher function, ignoring sequence
export function arrayContentsEqual(matchFn: MatchFn, a, b) {
  return a.length === b.length && a.every(aVal => b.some(bVal => matchFn(aVal, bVal)));
}
